<template>
  <v-app app :id="!$vuetify.breakpoint.xsOnly ? 'bg-login' : ''">
    <v-row
      no-gutters
      justify="center"
      :align="$vuetify.breakpoint.xsOnly ? null : 'center'"
    >
      <v-col
        cols="12"
        xs="12"
        sm="7"
        md="8"
        :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'py-1'"
      >
        <v-card
          tile
          :class="
            $vuetify.breakpoint.xsOnly
              ? 'elevation-0 animate__animated animate__fadeIn'
              : 'elevation-4 animate__animated animate__fadeIn'
          "
        >
          <v-row
            no-gutters
            class="animated fadeIn delay-1s"
            :justify="
              !$vuetify.breakpoint.xsOnly && !$vuetify.breakpoint.smOnly
                ? null
                : 'center'
            "
            :align="
              !$vuetify.breakpoint.xsOnly && !$vuetify.breakpoint.smOnly
                ? null
                : 'center'
            "
          >
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="!$vuetify.breakpoint.xsOnly && !$vuetify.breakpoint.smOnly"
              class="login_main_bg"
            ></v-col>
            <v-col
              cols="12"
              sm="12"
              :class="$vuetify.breakpoint.xsOnly ? 'pa-0 mt-0' : 'pa-0'"
              v-if="$vuetify.breakpoint.smOnly || $vuetify.breakpoint.xsOnly"
            >
              <div class="login_main_bg_tablet_mobile"></div>
            </v-col>
            <v-col cols="12" xs="12" sm="10" md="6" style="padding: 12% 5%">
              <v-row justify="center" align="center">
                <v-col
                  cols="11"
                  sm="12"
                  md="12"
                  :class="
                    $vuetify.breakpoint.xsOnly
                      ? 'px-0'
                      : !$vuetify.breakpoint.xsOnly &&
                        !$vuetify.breakpoint.smOnly
                      ? 'pa-0'
                      : ''
                  "
                >
                  <v-container fluid>
                    <h2 class="font-kanit-bold">เข้าสู่ระบบ</h2>
                    <v-card :class="mobile ? '  mt-6' : ' mt-6'">
                      <v-container>
                        <v-card-text>
                          <v-form ref="loginform" @submit.prevent="authLogIn()">
                            <v-row class="py-0" justify="center">
                              <v-col
                                cols="12"
                                class="py-0 change_password_text_label"
                              >
                                <v-text-field
                                  v-model="username"
                                  :rules="rule_username"
                                  label="บัญชีผู้ใช้"
                                  prepend-inner-icon="mdi-account-circle"
                                  required
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                class="py-0 change_password_text_label"
                              >
                                <v-text-field
                                  v-model="password"
                                  :rules="rule_password"
                                  label="รหัสผ่าน"
                                  prepend-inner-icon="mdi-key"
                                  required
                                  :append-icon="
                                    show1 ? 'mdi-eye' : 'mdi-eye-off'
                                  "
                                  :type="show1 ? 'text' : 'password'"
                                  @click:append="show1 = !show1"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" class>
                                <a
                                  class="float-right font-kanit-light"
                                  color="primary"
                                  style="
                                    text-decoration: underline;
                                    font-size: 12px;
                                  "
                                  @click="$router.push('forgetpassword')"
                                  >ลืมรหัสผ่าน?</a
                                >
                              </v-col>
                              <v-col cols="12" sm="12" md="12" class>
                                <v-btn
                                  :loading="btn_login"
                                  type="submit"
                                  class="font-kanit-light"
                                  block
                                  dark
                                  color="fourth"
                                  >เข้าสู่ระบบ</v-btn
                                >
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-card-text>
                      </v-container>
                    </v-card>
                  </v-container>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-app>
</template>
<script>
export default {
  data() {
    return {
      btn_login: false,
      token: null,
      token_expired: null,
      show1: false,
      username: "",
      password: "",
      rule_password: [(v) => !!v || "กรุณากรอกรหัสผ่าน"],
      rule_username: [(v) => !!v || "กรุณากรอกชื่อผู้ใช้"],
    };
  },
  computed: {
    mobile() {
      if (this.$vuetify.breakpoint.width < 375) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 375 ||
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (
        this.$vuetify.breakpoint.width >= 768 ||
        this.$vuetify.breakpoint.width <= 1920
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    async authLogIn() {
      if (this.$refs.loginform.validate()) {
        this.btn_login = true;
        let data = { client_id: "FW01", secret_key: "hv3ohTXsTzoa9tG" };
        var header_token = {
          headers: {
            token: "siamchai-token-dev",
            // "Access-Control-Allow-Origin": "*",
            // "Content-type": "Application/json",
            // "Access-Control-Allow-Credentials": true
          },
        };
        // console.log(header_token);
        // this.axios({
        //   methods: "POST",
        //   url: process.env.VUE_APP_API + "/api/v1/login",
        //   data: data,
        //   headers: {
        //     token: "siamchai-token-dev"
        //   }
        // }).then(response => {
        //   console.log(response);
        //   if (response.status == "OK") {
        //     // this.$session.set("token", response.result.token_key);
        //     // await this.postLogIn()
        //   }
        // });
        this.axios
          .post(
            process.env.VUE_APP_API + "/api/v1/auth_service",
            data,
            header_token
          )
          .then((response) => {
            // console.log(response);
            if (
              response.data.status == "OK" &&
              response.data.status != "FAIL"
            ) {
              this.token = response.data.result.token_key;
              this.token_expired = response.data.result.token_expired;
              //
              this.postLogIn();
            }
          })
          .catch((err) => {
            this.btn_login = false;
            this.$swal.fire({
              icon: "error",
              width: 500,
              title: "เกิดข้อผิดพลาด",
              showConfirmButton: false,
              timer: 5000,
              showCloseButton: true,
            });
          });
      }
    },
    postLogIn() {
      let header_token = {
        headers: {
          token: this.token,
        },
      };
      // console.log(header_token);
      let data = {
        username: this.username,
        password: this.password,
      };
      this.axios
        .post(process.env.VUE_APP_API + "/api/v1/login_web", data, header_token)
        .then((response) => {
          // console.log(response.data.result);
          // console.log(this.token);
          if (response.data.status == "OK" && response.data.status != "FAIL") {
            this.$session.set("token", this.token);
            this.$session.set("profile", response.data.result);
            this.$session.set("token_expired", this.token_expired);
            this.$session.set("role", response.data.result.role_name);

            this.btn_login = false;
            let token_check = this.$session.get("token");
            // console.log(token_check);
            if (token_check) {
              this.$swal.fire({
                icon: "success",
                title: "เข้าสู่ระบบสำเร็จ",
                showConfirmButton: false,
                timer: 2000,
                showCloseButton: true,
              });
              this.$router.push("/promotion");
            }
          } else {
            this.$swal.fire({
              icon: "error",
              title: response.data.message,
              text: "กรุณาตรวจสอบข้อมูลของท่านอีกครั้ง",
              showConfirmButton: true,
              timer: 5000,
              showCloseButton: true,
            });
          }
          this.btn_login = false;
          // if (response.data.message === "login success") {
          //   this.$session.set("token", response.data.access_token);
          //   // this.$session.set("permission", response.data.permission);
          //   // this.$session.set("permission", "admin");
          //   this.$swal.fire("เข้าสู่ระบบสำเร็จ", "OK", "success");

          //   let check_token = "";
          //   check_token = this.$session.get("token");
          //   check_token != "" ? this.$emit("show_login_btn", "token") : "";
          //   console.log(this.$session.getAll());
          //   window.location.reload();

          //   this.close();
          // } else if (response.data.message === "Does not exist this username") {
          //   this.$swal.fire("ชื่อผู้ใช้ไม่ถูกต้อง", " ", "error");
          // } else if (response.data.message === "Unauthorization") {
          //   this.$swal.fire("รหัสผ่านไม่ถูกต้อง", " ", "error");
          // }
        })
        .catch((err) => {
          this.btn_login = false;
          this.$swal.fire({
            icon: "error",
            width: 500,
            title: "เกิดข้อผิดพลาด",
            showConfirmButton: false,
            timer: 5000,
            showCloseButton: true,
          });
        });
      // } else {
      //   // console.log("invalid");
      //   // this.$swal.fire("InValiD DaTa", "WarnIng", "warning");
    },

    // logIn() {
    //   if (this.$refs.loginform.validate()) {
    //     async this.authLogIn()
    //   }
    // }
  },
};
</script>